// extracted by mini-css-extract-plugin
export default {"orderSection":"order-section_orderSection__wYnaP"};